"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCompactKetteWithSerieTypeUnsafe = exports.isCompactKetteWithSerieType = exports.isCompactKette = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const isCompactKette = (whatever) => (0, echain_shared_modelling_1.isWithRequired)(whatever, {
    KetteSerieType: Boolean,
    EchainId: true,
    ArtNr: true,
});
exports.isCompactKette = isCompactKette;
const isCompactKetteWithSerieType = (whatever, ketteSerieType) => (0, exports.isCompactKette)(whatever) && whatever.KetteSerieType === ketteSerieType;
exports.isCompactKetteWithSerieType = isCompactKetteWithSerieType;
const isCompactKetteWithSerieTypeUnsafe = (whatever, ketteSerieType) => whatever.KetteSerieType === ketteSerieType;
exports.isCompactKetteWithSerieTypeUnsafe = isCompactKetteWithSerieTypeUnsafe;
//# sourceMappingURL=CompactKette.js.map